import React from "react";
import styles from "./SocialMediaIcons.module.css";
import Tooltip from "../../Tooltip/Tooltip";
export const LinkedinIcon = (props) => {
  return (
    <div className={[styles.IconContainer, styles.Linkedin].join(" ")}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 24 24"
        viewBox="0 0 24 24"
      >
        <g fill="#0077b5">
          <path d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z" />
          <path d="m.396 7.977h4.976v16.023h-4.976z" />
          <path d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z" />
        </g>
      </svg>
      <div className={styles.TooltipContainer}>
        <Tooltip>لینکدین</Tooltip>
      </div>
    </div>
  );
};

export const TelegramIcon = (props) => {
  return (
    <div className={[styles.IconContainer, styles.Telegram].join(" ")}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          d="m9.417 15.181-.397 5.584c.568 0 .814-.244 1.109-.537l2.663-2.545 5.518 4.041c1.012.564 1.725.267 1.998-.931l3.622-16.972.001-.001c.321-1.496-.541-2.081-1.527-1.714l-21.29 8.151c-1.453.564-1.431 1.374-.247 1.741l5.443 1.693 12.643-7.911c.595-.394 1.136-.176.691.218z"
          fill="#039be5"
        />
      </svg>
      <div className={styles.TooltipContainer}>
        <Tooltip>تلگرام</Tooltip>
      </div>
    </div>
  );
};
export const TwitterIcon = (props) => {
  return (
    <div className={[styles.IconContainer, styles.Twitter].join(" ")}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          d="m21.552 7.749c0-.217-.008-.428-.018-.636.976-.693 1.797-1.558 2.466-2.554v-.001c-.893.391-1.843.651-2.835.777 1.02-.609 1.799-1.566 2.165-2.719-.951.567-2.001.967-3.12 1.191-.903-.962-2.19-1.557-3.594-1.557-2.724 0-4.917 2.211-4.917 4.921 0 .39.033.765.114 1.122-4.09-.2-7.71-2.16-10.142-5.147-.424.737-.674 1.58-.674 2.487 0 1.704.877 3.214 2.186 4.089-.791-.015-1.566-.245-2.223-.606v.054c0 2.391 1.705 4.377 3.942 4.835-.752.206-1.678.198-2.221.078.637 1.948 2.447 3.381 4.597 3.428-1.674 1.309-3.8 2.098-6.101 2.098-.403 0-.79-.018-1.177-.067 2.18 1.405 4.762 2.208 7.548 2.208 9.054 0 14.004-7.5 14.004-14.001z"
          fill="#55acee"
        />
      </svg>
      <div className={styles.TooltipContainer}>
        <Tooltip>توییتر</Tooltip>
      </div>
    </div>
  );
};
export const InstagramIcon = (props) => {
  return (
    <div className={[styles.IconContainer, styles.Instagram].join(" ")}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511 511.9">
        <path d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0" />
        <path d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0" />
        <path d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0" />
      </svg>
      <div className={styles.TooltipContainer}>
        <Tooltip>اینستاگرام</Tooltip>
      </div>
    </div>
  );
};
export const WhatsappIcon = (props) => {
  return (
    <div className={[styles.IconContainer, styles.Whatsapp].join(" ")}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          d="m20.52 3.449c-2.28-2.204-5.28-3.449-8.475-3.449-9.17 0-14.928 9.935-10.349 17.838l-1.696 6.162 6.335-1.652c2.76 1.491 5.021 1.359 5.716 1.447 10.633 0 15.926-12.864 8.454-20.307z"
          fill="#eceff1"
        />
        <path
          d="m12.067 21.751-.006-.001h-.016c-3.182 0-5.215-1.507-5.415-1.594l-3.75.975 1.005-3.645-.239-.375c-.99-1.576-1.516-3.391-1.516-5.26 0-8.793 10.745-13.19 16.963-6.975 6.203 6.15 1.848 16.875-7.026 16.875z"
          fill="#4caf50"
        />
        <path
          d="m17.507 14.307-.009.075c-.301-.15-1.767-.867-2.04-.966-.613-.227-.44-.036-1.617 1.312-.175.195-.349.21-.646.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.77-1.66-2.07-.293-.506.32-.578.878-1.634.1-.21.049-.375-.025-.524-.075-.15-.672-1.62-.922-2.206-.24-.584-.487-.51-.672-.51-.576-.05-.997-.042-1.368.344-1.614 1.774-1.207 3.604.174 5.55 2.714 3.552 4.16 4.206 6.804 5.114.714.227 1.365.195 1.88.121.574-.091 1.767-.721 2.016-1.426.255-.705.255-1.29.18-1.425-.074-.135-.27-.21-.57-.345z"
          fill="#fafafa"
        />
      </svg>
      <div className={styles.TooltipContainer}>
        <Tooltip>واتس اپ</Tooltip>
      </div>
    </div>
  );
};
export const EmailIcon = (props) => {
  return (
    <div className={[styles.IconContainer, styles.Email].join(" ")}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        id="Capa_1"
        viewBox="0 0 512 512"
        width="512"
      >
        <linearGradient
          id="SVGID_1_"
          gradientUnits="userSpaceOnUse"
          x1="256"
          x2="256"
          y1="444.531"
          y2="16.168"
        >
          <stop offset="0" stop-color="#fd3a84" />
          <stop offset="1" stop-color="#ffa68d" />
        </linearGradient>
        <linearGradient
          id="SVGID_2_"
          gradientUnits="userSpaceOnUse"
          x1="256"
          x2="256"
          y1="495.832"
          y2="105.832"
        >
          <stop offset="0" stop-color="#ffc2cc" />
          <stop offset="1" stop-color="#fff2f4" />
        </linearGradient>
        <g id="Mail_74_">
          <g>
            <g>
              <path
                d="m506.3 199.131-222.7-174c-15.599-12-39.3-12-55.499.3l-222.401 173.7c-.901.601-1.8 1.5-2.401 2.401l174.101 242.999h157.2l174.1-242.699c-.6-1.201-1.499-1.8-2.4-2.701z"
                fill="url(#SVGID_1_)"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="m508.7 201.832-234.1 182.699c-5.099 3.9-11.7 6.301-18.6 6.301s-13.5-2.4-18.6-6.301l-234.1-182.999c-2.1 2.699-3.3 6-3.3 9.3v240c0 24.899 20.099 45 45 45h422c24.901 0 45-20.101 45-45v-240c0-3.3-1.199-6.601-3.3-9zm-252.7 114c12.012 0 23.789-2.021 35.01-6.006 7.822-2.769 11.895-11.338 9.141-19.146-2.813-7.837-11.455-11.88-19.16-9.126-7.998 2.842-16.406 4.277-24.99 4.277-41.367 0-75-33.647-75-75s33.633-75 75-75 75 33.647 75 75c0 8.276-6.738 15-15 15s-15-6.724-15-15c0-24.814-20.186-45-45-45s-45 20.186-45 45 20.186 45 45 45c11.567 0 22.02-4.508 30-11.704 7.98 7.196 18.433 11.704 30 11.704 24.814 0 45-20.186 45-45-1.42-62.833-50.646-105-105-105-57.891 0-105 47.109-105 105s47.108 105.001 104.999 105.001zm0-90c-8.262 0-15-6.724-15-15s6.738-15 15-15 15 6.724 15 15-6.738 15-15 15z"
                fill="url(#SVGID_2_)"
              />
            </g>
          </g>
        </g>
      </svg>
      <div className={styles.TooltipContainer}>
        <Tooltip>ایمیل</Tooltip>
      </div>
    </div>
  );
};
export const PhoneIcon = (props) => {
  return (
    <div className={[styles.IconContainer, styles.Phone].join(" ")}>
      <svg
        className={styles.Icon}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        id="Capa_1"
        x="0px"
        y="0px"
        viewBox="0 0 384 384"
        xmlSpace="preserve"
      >
        <g>
          <g>
            <path d="M353.188,252.052c-23.51,0-46.594-3.677-68.469-10.906c-10.719-3.656-23.896-0.302-30.438,6.417l-43.177,32.594    c-50.073-26.729-80.917-57.563-107.281-107.26l31.635-42.052c8.219-8.208,11.167-20.198,7.635-31.448    c-7.26-21.99-10.948-45.063-10.948-68.583C132.146,13.823,118.323,0,101.333,0H30.813C13.823,0,0,13.823,0,30.813    C0,225.563,158.438,384,353.188,384c16.99,0,30.813-13.823,30.813-30.813v-70.323C384,265.875,370.177,252.052,353.188,252.052z" />
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
      <div className={styles.TooltipContainer}>
        <Tooltip>تلفن</Tooltip>
      </div>
    </div>
  );
};
export const AddressIcon = (props) => {
  return (
    <div className={[styles.IconContainer, styles.Address].join(" ")}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#000000"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
      </svg>
      <div className={styles.TooltipContainer}>
        <Tooltip>آدرس</Tooltip>
      </div>
    </div>
  );
};
